(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "a9e2291900a7903361f75f2c3b14d1a9a5abc152"
};